var l = Object.defineProperty;
var u = (r, e, t) => e in r ? l(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var d = (r, e, t) => u(r, typeof e != "symbol" ? e + "" : e, t);
import { FieldDirectiveEnum as f } from "../../app/field/types/index.js";
import { objectDeclarationFields as g, objectDeclarationToProperties as O } from "./step-params-generic-type-mutation-handler.js";
import { StepParamsOneOfSchemaHandler as h } from "./step-params-one-of-schema-handler.js";
class F {
  constructor(e, t) {
    d(this, "isGenericTypeStepHandler", !0);
    d(this, "stepParamsOneOfSchemaHandler");
    var c, m;
    const a = ["id", "createdAt", "updatedAt", "ofType"], i = [
      "ofType",
      "fields",
      "namespace",
      "directives",
      "connections"
    ], n = ((c = e.properties) == null ? void 0 : c.input).items, o = {
      oneOf: (m = t.types) == null ? void 0 : m.map((s) => ({
        type: "object",
        properties: {
          ofType: {
            type: "string",
            enum: [s.id]
          },
          input: {
            type: "array",
            items: {
              ...n,
              properties: {
                ...n.properties,
                ...O(
                  s.id,
                  a,
                  t
                )
              },
              required: [
                ...n.required ?? [],
                ...g(
                  s.id,
                  a,
                  t
                ).filter(
                  (p) => p.directives.includes(f.REQUIRED)
                ).map((p) => p.name)
              ]
            }
          },
          required: ["input", "ofType"]
        }
      })),
      routingParams: ["ofType"]
    };
    this.stepParamsOneOfSchemaHandler = new h(
      o,
      i,
      !1,
      this.getOfTypeValue.bind(this)
    );
  }
  get schema() {
    return this.stepParamsOneOfSchemaHandler.schema;
  }
  getFields(e) {
    return this.stepParamsOneOfSchemaHandler.getFields(e);
  }
  getUpdatedState(e, t, a) {
    return this.stepParamsOneOfSchemaHandler.getUpdatedState(
      e,
      t,
      a
    );
  }
  validate(e) {
    return this.stepParamsOneOfSchemaHandler.validate(e);
  }
  getFieldValue(e, t) {
    return this.stepParamsOneOfSchemaHandler.getFieldValue(e, t);
  }
  getUpdatedParamsConfigState(e, t, a, i) {
    return this.stepParamsOneOfSchemaHandler.getUpdatedParamsConfigState(
      e,
      t,
      a,
      i
    );
  }
  getFieldLogicLanguage(e, t) {
    return this.stepParamsOneOfSchemaHandler.getFieldLogicLanguage(
      e,
      t
    );
  }
  getFieldLogicLanguageOptions(e, t) {
    return this.stepParamsOneOfSchemaHandler.getFieldLogicLanguageOptions(
      e,
      t
    );
  }
  getInitialState(e, t) {
    return {
      ofType: t && "isGenericTypeStepHandler" in t ? t.getOfTypeValue(e) : void 0,
      namespace: "",
      input: []
    };
  }
  getOfTypeValue(e) {
    return e.ofType;
  }
}
export {
  F as GenericTypeStepBatchMutationHandler
};
